import { useQuery } from "@tanstack/react-query";
import { FILTER_OPERATIONS, QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getPledgesPaginated = ({
  churchId,
  campaignId,
  page,
  pageSize,
  queries
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  if (queries.startDate && queries.endDate) {
    queryBuilder.filter({
      updated_at: [
        {
          operator: FILTER_OPERATIONS.BETWEEN,
          value: [queries.startDate, queries.endDate]
        }
      ]
    });
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/churches/${churchId}/campaigns/${campaignId}/pledges-paginated${queryString}`
  );
};

export const usePledgesPaginated = ({
  churchId,
  campaignId,
  config,
  page,
  pageSize,
  queries = {}
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "pledges-paginated",
      churchId,
      campaignId,
      page,
      pageSize,
      JSON.stringify(queries)
    ],
    queryFn: () =>
      getPledgesPaginated({ churchId, campaignId, page, pageSize, queries })
  });
};
